import { Component, Input, Signal, computed, inject } from '@angular/core';

import { MatChipsModule } from '@angular/material/chips';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { WidgetDataStore } from '../../../../stores/widget-data.store';
import { ChipsWidget } from '../../models';

@Component({
  selector: 'siat-chips-widget',
   
  imports: [
    MatChipsModule, TranslatePipe
  ],
  templateUrl: './chips-widget.component.html',
  styleUrl: './chips-widget.component.scss',
})
export class ChipsWidgetComponent {
  @Input() widget: ChipsWidget;

  private widgetDataStore = inject(WidgetDataStore);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private idPaziente = this.route.snapshot.params['idAnagrafica'];
  // Get widget data from store reactively
  widgetData: Signal<string[]> = computed(() => {
    const data = this.widgetDataStore.getWidgetData<string[]>(
      this.widget?.id
    );
    return data || [];
  });

  gotTo(type: string) {
    this.router.navigateByUrl(`/home/scheda-paziente/${this.idPaziente}/diario/${type}`);
  }
}
